"use strict";
exports.__esModule = true;
exports.OauthType = void 0;
var OauthType;
(function (OauthType) {
    OauthType["EMAIL"] = "email";
    OauthType["GOOGLE"] = "google";
    OauthType["GITHUB"] = "github";
})(OauthType = exports.OauthType || (exports.OauthType = {}));
